var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpeningHrs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.625C7.7175 2.625 2.625 7.7175 2.625 14C2.625 20.2825 7.7175 25.375 14 25.375C20.2825 25.375 25.375 20.2825 25.375 14C25.375 7.7175 20.2825 2.625 14 2.625ZM14.875 7C14.875 6.76794 14.7828 6.54538 14.6187 6.38128C14.4546 6.21719 14.2321 6.125 14 6.125C13.7679 6.125 13.5454 6.21719 13.3813 6.38128C13.2172 6.54538 13.125 6.76794 13.125 7V14C13.125 14.483 13.517 14.875 14 14.875H19.25C19.4821 14.875 19.7046 14.7828 19.8687 14.6187C20.0328 14.4546 20.125 14.2321 20.125 14C20.125 13.7679 20.0328 13.5454 19.8687 13.3813C19.7046 13.2172 19.4821 13.125 19.25 13.125H14.875V7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningHrs);
export default __webpack_public_path__ + "static/media/openingHrs.f80dcc730a60a27f6c4c431d99f8d71b.svg";
export { ForwardRef as ReactComponent };